module.exports = __webpack_public_path__ + "static/media/r12.a934c152.png";